export default __webpack_public_path__ + "static/media/self_regulatory.8b9967d2.png";